export default __webpack_public_path__ + "static/media/map_final_al_ankh.70de4685.jpg";